/**
 * Frame <-> second conversions for the configured timeline framerate.
 *
 * Kept as plain functions so that hooks which only need them inside an event handler
 * (`useObjectActions`, `useAnimationActions`) can call them with a value read from
 * `store.getState()` instead of subscribing to `timelinePreferences` several hundred times.
 */
export const framesToSeconds = (framerate: number, value: number): number => {
    switch (framerate) {
        case 50:
            return value * 0.02
        case 25:
            return value * 0.04
        default:
            return value
    }
}

export const secondsToFrames = (framerate: number, time: number): number => {
    switch (framerate) {
        case 50:
            return Math.round(time * 50 * 100) / 100
        case 25:
            return Math.round(time * 25 * 100) / 100
        default:
            return time
    }
}
